import styled, { keyframes } from "styled-components";
import { variant } from "styled-system";
import { Flex } from "../../Flex";
const slideDown = keyframes `
  0% { margin-top: -50px; margin-bottom: 50px; opacity: 0; }
  50% { opacity: 1; }
  100% { margin-top: 0; margin-bottom: 0px; opacity: 1; }
`;
const modalContainerVariants = {
    fullscreen: {
        bottom: 4,
        left: 4,
        position: "absolute",
        right: 4,
        top: 4,
    },
    normal: {
        position: "relative",
    },
};
export const ModalContainer = styled(Flex) `
  position: relative;
  flex-direction: column;
  justify-content: space-between;
  animation-name: ${slideDown};
  animation-duration: 0.5s;
  ${({ theme: { radii, shadows, colors: { modalColors }, }, }) => ({
    backgroundColor: modalColors.modalBackground,
    borderRadius: radii[1],
    boxShadow: shadows.modal,
})}

  ${variant({ variants: modalContainerVariants })}
`;
